import { render, staticRenderFns } from "./dataFormSubsidiary2.vue?vue&type=template&id=ac5b5962&scoped=true"
import script from "./dataFormSubsidiary2.vue?vue&type=script&lang=js"
export * from "./dataFormSubsidiary2.vue?vue&type=script&lang=js"
import style0 from "./dataFormSubsidiary2.vue?vue&type=style&index=0&id=ac5b5962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b5962",
  null
  
)

export default component.exports